import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-spinner',
  imports: [MatProgressSpinnerModule, NgClass],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  isSpinnerActive = input.required<boolean>();
  strokeWidth = input.required<number>();
  diameter = input.required<number>();
  className = input.required<string>();
}
